import { globalStyle, style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { fillScope } from '@customerio/pluma-components/css/utils';

export const diagramContainer = style(
  {
    padding: themeVars.space['200'],
    borderRadius: themeVars.radius['3'],
    overflow: 'auto',
    background: themeVars.color['surface-content'],
  },
  'diagram-container',
);

globalStyle(`${diagramContainer} > svg`, {
  display: 'block',
  maxWidth: '100%',
  height: 'auto',
});

export const errorContainer = style(
  {
    padding: themeVars.space['200'],
    borderRadius: themeVars.radius['3'],
    background: fillScope('critical', 'subtle'),
    color: themeVars.color['scope-critical-text'],
    fontSize: themeVars['font-size']['sm'],
  },
  'error-container',
);
